import { addAndTrack, simpleAnTmaker } from "../../../calculators/helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { mediumPAs } from "../config";
import {
  checkAscs,
  checkCharMC,
  checkCons,
  makeTlBnes,
  xtraTlLv
} from "../helpers";
import { applyPct } from "../../../helpers";

const Layla = {
  code: 61,
  name: "Layla",
  icon: "1/1a/Layla_Icon",
  sideIcon: "9/90/Character_Layla_Side_Icon",
  rarity: 4,
  nation: "Sumeru",
  vision: "Cryo",
  weapon: "Sword",
  stats: [
    { "Base HP": 930, "Base ATK": 18, "Base DEF": 55 },
    { "Base HP": 2389, "Base ATK": 47, "Base DEF": 141 },
    { "Base HP": 3084, "Base ATK": 60, "Base DEF": 182 },
    { "Base HP": 4619, "Base ATK": 90, "Base DEF": 273 },
    { "Base HP": 5113, "Base ATK": 100, "Base DEF": 302, "HP%": 6 },
    { "Base HP": 5881, "Base ATK": 115, "Base DEF": 347, "HP%": 6 },
    { "Base HP": 6540, "Base ATK": 128, "Base DEF": 386, "HP%": 12 },
    { "Base HP": 7308, "Base ATK": 143, "Base DEF": 432, "HP%": 12 },
    { "Base HP": 7801, "Base ATK": 152, "Base DEF": 461, "HP%": 12 },
    { "Base HP": 8569, "Base ATK": 167, "Base DEF": 506, "HP%": 12 },
    { "Base HP": 9062, "Base ATK": 177, "Base DEF": 535, "HP%": 18 },
    { "Base HP": 9831, "Base ATK": 192, "Base DEF": 581, "HP%": 18 },
    { "Base HP": 10324, "Base ATK": 202, "Base DEF": 610, "HP%": 24 },
    { "Base HP": 11092, "Base ATK": 217, "Base DEF": 655, "HP%": 24 }
  ],
  actvTalents: [
    {
      type: "Normal Attack",
      name: "Sword of the Radiant Path",
      desc: [],
      stats: [
        {
          name: "1-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 51.22,
          multType: 1
        },
        {
          name: "2-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 48.48,
          multType: 1
        },
        {
          name: "3-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 72.97,
          multType: 1
        },
        {
          name: "Charged Attack DMG",
          dmgTypes: ["CA", "Physical"],
          baseMult: [47.73, 52.55],
          multType: 1
        },
        ...mediumPAs
      ]
    },
    {
      type: "Elemental Skill",
      name: "Nights of Formal Focus",
      image: "9/90/Talent_Nights_of_Formal_Focus",
      desc: [],
      getXtraLv: xtraTlLv.cons3,
      stats: [
        {
          name: "Skill DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 12.8,
          multType: 2
        },
        {
          name: "Shooting Star DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 14.72,
          multType: 2,
          getTlBnes: ({ char, selfMCs, ATTRs }) =>
            makeTlBnes([
              [
                checkCharMC(Layla.buffs, char, selfMCs.BCs, 1),
                "flat",
                [1, 4],
                applyPct(ATTRs.HP, 1.5)
              ],
              [
                checkCharMC(Layla.buffs, char, selfMCs.BCs, 4),
                "pct",
                [0, 6],
                40
              ]
            ])
        },
        {
          name: "Base Shield DMG Absorption",
          baseSType: "HP",
          baseMult: 10.8,
          multType: 2,
          baseFlat: 1040,
          flatType: 3,
          getTlBnes: ({ char, selfMCs }) =>
            makeTlBnes(
              checkCharMC(Layla.buffs, char, selfMCs.BCs, 2),
              "pct",
              [0, 1],
              20
            )
        }
      ],
      otherStats: (lv) => [
        { name: "Shield Duration", value: "12s" },
        { name: "CD", value: "12s" }
      ]
    },
    {
      type: "Elemental Burst",
      name: "Dream of the Star-Stream Shaker",
      image: "b/b4/Talent_Dream_of_the_Star-Stream_Shaker",
      desc: [],
      getXtraLv: xtraTlLv.cons5,
      stats: [
        {
          name: "Starlight Slug DMG",
          baseSType: "HP",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 4.65,
          multType: 2
        }
      ],
      otherStats: () => [
        { name: "Duration", value: "12s" },
        { name: "CD", value: "12s" }
      ],
      energyCost: 40
    }
  ],
  pasvTalents: [
    {
      type: "Ascension 1",
      name: "Like Nascent Light",
      image: "6/6d/Talent_Like_Nascent_Light",
      desc: (
        <>
          While the Curtain of Slumber is active, the Deep Sleep effect will
          activate each time the Curtain gains a Night Star:
          <br />• The <Green>Shield Strength</Green> of a character under the
          effect of the Curtain of Slumber increases by <Green b>6%</Green>.
          <br />• This effect can have a maximum of <Green b>4</Green>{" "}
          <Green>stacks</Green> and persists until the Curtain of Slumber
          disappears.
        </>
      )
    },
    {
      type: "Ascension 4",
      name: "Sweet Slumber Undisturbed",
      image: "3/32/Talent_Sweet_Slumber_Undisturbed",
      desc: (
        <>
          The <Green>DMG</Green> dealt by the Shooting Stars fired by Nights of
          Formal Focus is increased by <Green b>1.5%</Green> of Layla's{" "}
          <Green>Max HP</Green>.
        </>
      )
    },
    {
      type: "Passive",
      name: "Talent for Daily Life",
      image: "5/51/Talent_Shadowy_Dream-Signs"
    }
  ],
  constellation: [
    {
      name: "Fortress of Fantasy",
      image: "5/50/Constellation_Fortress_of_Fantasy",
      get desc() {
        return (
          <>
            {this.buff}
            <br />
            Additionally, when unleashing Nights of Formal Focus, she will
            generate a shield for any nearby party members who are not being
            protected by a Curtain of Slumber. This shield will have 35% of the
            absorption of a Curtain of Slumber, will last for 12s, and will
            absorb Cryo DMG with 250% effectiveness.
          </>
        );
      },
      buff: (
        <>
          The <Green b>Shield Absorption</Green> of the Curtain of Slumber
          generated by Nights of Formal Focus is increased by{" "}
          <Green b>20%</Green>.
        </>
      )
    },
    {
      name: "Light's Remit",
      image: "6/6a/Constellation_Light%27s_Remit",
      desc: (
        <>
          When Shooting Stars from Nights of Formal Focus strike opponents, they
          will each restore <Green>1</Green> <Green>Energy</Green> to Layla.
          Each Shooting Star can restore Energy to her in this manner once.
        </>
      )
    },
    {
      name: "Secrets of the Night",
      image: "6/66/Constellation_Secrets_of_the_Night",
      desc: "Nights of Formal Focus"
    },
    {
      name: "Starry Illumination",
      image: "a/ab/Constellation_Starry_Illumination",
      get desc() {
        return (
          <>
            {this.buff}
            <br />
            Open Mind can last up to 3s and will be removed 0.1s after dealing
            Normal or Charged Attack DMG.
          </>
        );
      },
      buff: (
        <>
          When Nights of Formal Focus starts to fire off Shooting Stars, it will
          grant all nearby party members the Open Mind effect, causing their{" "}
          <Green>Normal and Charged Attack DMG</Green> to increase based on{" "}
          <Green b>5%</Green> of Layla's <Green>Max HP</Green>.
        </>
      )
    },
    {
      name: "Stream of Consciousness",
      image: "8/8f/Constellation_Stream_of_Consciousness",
      desc: "Dream of the Star-Stream Shaker"
    },
    {
      name: "Radiant Soulfire",
      image: "b/b9/Constellation_Radiant_Soulfire",
      get desc() {
        return (
          <>
            {this.buff}
            <br />
            Additionally, the interval between the creation of Night Stars via
            Nights of Formal Focus is decreased by 20%.
          </>
        );
      },
      buff: (
        <>
          <Green>Shooting Stars</Green> from Nights of Formal Focus deal{" "}
          <Green b>40%</Green> <Green>increased DMG</Green>, and{" "}
          <Green>Starlight Slugs</Green> from Dream of the Star-Stream Shaker
          deal <Green b>40%</Green> <Green>increased DMG</Green>.
        </>
      )
    }
  ],
  buffs: [
    {
      index: 0,
      src: "Ascension 1 Passive Talent",
      desc: () => Layla.pasvTalents[0].desc,
      isGranted: checkAscs[1],
      affect: "party",
      selfLabels: ["Stacks"],
      labels: ["Stacks"],
      inputs: [1],
      inputTypes: ["select"],
      maxs: [4],
      addBnes: ({ ATTRs, inputs, tkDesc, tracker }) => {
        addAndTrack(tkDesc, ATTRs, "Shield Strength", 6 * inputs[0], tracker);
      }
    },
    {
      index: 1,
      src: "Ascension 4 Passive Talent",
      desc: () => Layla.pasvTalents[1].desc,
      isGranted: checkAscs[4],
      affect: "self"
    },
    {
      index: 2,
      src: "Constellation 1",
      desc: () => Layla.constellation[0].buff,
      isGranted: checkCons[1],
      affect: "self"
    },
    {
      index: 3,
      src: "Constellation 4",
      desc: () => Layla.constellation[3].buff,
      isGranted: checkCons[4],
      affect: "party",
      labels: ["Max HP"],
      inputs: [0],
      inputTypes: ["text"],
      maxs: [99999],
      addFinalBnes: ({ toSelf, ATTRs, hitBnes, inputs, tkDesc, tracker }) => {
        const maxHP = toSelf ? ATTRs.HP : inputs[0];
        const bnValue = applyPct(maxHP, 5);
        addAndTrack(tkDesc, hitBnes, ["NA.flat", "CA.flat"], bnValue, tracker);
      }
    },
    {
      index: 4,
      src: "Constellation 6",
      desc: () => Layla.constellation[5].buff,
      isGranted: checkCons[6],
      affect: "self",
      addBnes: simpleAnTmaker("hitBnes", "EB.pct", 40)
    }
  ]
};

export default Layla;
